import { useContext } from 'react'
import { EditableWish } from './types'
import { LootContext, PersonalLootContext } from './context'
import { difficulties } from 'app/frontend/types/custom/Difficulty'

export const useFindRelevantWish = (currentSpecId: number) => {
  const { difficulty, configuration } = useContext(LootContext)
  const { changes } = useContext(PersonalLootContext)

  return (item: wowaudit.WishlistItem) => {
    const wishId = `${item.id}-${difficulty}-${currentSpecId}-${configuration.id}`

    return (
      changes[wishId] ||
      item.wishes.find(
        (wish) =>
          wish.difficulty === difficulties.indexOf(difficulty) &&
          wish.specialization === currentSpecId &&
          configuration.id === wish.configuration_id,
      )
    )
  }
}

export const wishEmpty = (wish?: EditableWish) => {
  return !wish || wish.type === 'none'
}

export const levelColors = {
  huge: 'bg-destructive-foreground',
  big: 'bg-warning-foreground',
  small: 'bg-success-foreground',
  tiny: 'bg-muted-foreground',
  none: 'bg-transparent',
}
